import { render, staticRenderFns } from "./OnboardingPackages.vue?vue&type=template&id=464ccdb8"
import script from "./OnboardingPackages.vue?vue&type=script&lang=js"
export * from "./OnboardingPackages.vue?vue&type=script&lang=js"
import style0 from "./OnboardingPackages.vue?vue&type=style&index=0&id=464ccdb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports